import React, { useState, useContext, useEffect } from 'react'

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import {
    ColorWithOpacity,
    DarkBackgroundColor,
    DarkerBackgroundColor,
    IpsaGreen,
    InsightsPurple,
} from '../../highcharts/HighchartsStyleHelper'

import SidebarContext from '../../context/SidebarContext'

const ActivityGauge = ({
    title,
    current,
    projected,
    goal,
    backgroundColor = DarkBackgroundColor,
}) => {
    const CurrentPercentage = Math.floor((current / goal) * 100)
    const ProjectedPercentage = Math.floor((projected / goal) * 100)

    const [internalChart, setInternatChart] = useState(null)

    const { sidebarOpen } = useContext(SidebarContext)

    const reflowChart = (chart, timeout) => {
        setTimeout(() => {
            if (chart && chart.reflow) {
                chart.reflow()
            }
        }, timeout)
    }

    useEffect(() => {
        reflowChart(internalChart, 200)
    }, [sidebarOpen])

    const options = {
        chart: {
            type: 'solidgauge',
            height: null,
            backgroundColor: backgroundColor,
        },

        title: {
            text: title,
        },

        tooltip: {
            borderWidth: 0,
            backgroundColor: backgroundColor,
            shadow: false,
            valueSuffix: '%',
            pointFormat:
                '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>',
            positioner: function (labelWidth) {
                return {
                    x: (this.chart.chartWidth - labelWidth) / 2,
                    y: this.chart.plotHeight / 2 + 15,
                }
            },
        },

        pane: {
            startAngle: 0,
            endAngle: 360,
            background: [
                {
                    // Track for Move
                    outerRadius: '85%',
                    innerRadius: '60%',
                    backgroundColor: ColorWithOpacity(DarkerBackgroundColor, 0.8),
                    borderWidth: 0,
                },
            ],
        },

        yAxis: {
            min: 0,
            max: 100,
            lineWidth: 0,
            tickPositions: [],
        },

        plotOptions: {
            solidgauge: {
                dataLabels: {
                    enabled: false,
                },
                linecap: 'round',
                stickyTracking: false,
                rounded: true,
            },
        },

        series: [
            {
                name: 'Projected',
                data: [
                    {
                        color: InsightsPurple,
                        radius: '85%',
                        innerRadius: '60%',
                        y: ProjectedPercentage,
                    },
                ],
            },
            {
                name: 'Premiums',
                data: [
                    {
                        color: IpsaGreen,
                        radius: '85%',
                        innerRadius: '60%',
                        y: CurrentPercentage,
                    },
                ],
            },
        ],
    }

    return <HighchartsReact highcharts={Highcharts} options={options} callback={setInternatChart} />
}

export default ActivityGauge
